
export default  {
    months: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤษจิกายน',
        'ธันวาคม'
    ],
    groups: [
        "สำคัญมาก (VIP)",
        "สำคัญ (IP)",
        "ตระหนัก (Watching List)",
        "ทั่วไป (Normal List)",
        "แทบไม่ใช้บริการ (Uncertainty List)"
    ]
}